import datetime from "./datetime";
import date from "./date";
import bytes from "./bytes";
import { typeDocument, libelleDateDocument,sousTypeDocument, libelleDateEffet } from "./typedocument";
import butassociation from "./butassociation";
import civilite from "./civilite";
import etatassociation from "./etatassociation";
import typeevenement from "./typeevenement";
import typerequete from "./typerequete";
import etatrequete from "./etatrequete";
import soustyperequete from "./soustyperequete";
import typepourvoi from "./typepourvoi";

export default {
    install(Vue) {
        Vue.filter("datetime", datetime);
        Vue.filter("date", date);
        Vue.filter("bytes", bytes);
        Vue.filter("typedocument", typeDocument);
        Vue.filter("libelledatedocument", libelleDateDocument);
        Vue.filter("libelledateeffet", libelleDateEffet);
        Vue.filter("soustypedocument", sousTypeDocument);
        Vue.filter("butassociation", butassociation);
        Vue.filter("civilite", civilite);
        Vue.filter("etatassociation", etatassociation);
        Vue.filter("typeevenement", typeevenement);
        Vue.filter("soustyperequete", soustyperequete);
        Vue.filter("typerequete", typerequete);
        Vue.filter("etatrequete", etatrequete);
        Vue.filter("typepourvoi", typepourvoi);
    }
}
